import React, { useState, useEffect } from 'react';
import {
  IconButton,
  Badge,
  Dialog,
  DialogTitle,
  DialogContent,
  Select,
  MenuItem,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  Typography,
  Box,
  Tooltip
} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useLocation } from 'react-router-dom';
import { base_url } from '../../api/api-url';


const NotificationDialog = ({ userEmail }) => {
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [range, setRange] = useState('today');
  const [unseenCount, setUnseenCount] = useState(0);
   const location=useLocation()
  // Fetch notifications
  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${base_url}/notifications?email=${userEmail}&range=${range}`);
      const data = await res.json();
      if (data.status) {
        setNotifications(data.data);
        const unseen = data.data.filter(n => !n.seen).length;
        setUnseenCount(unseen);
      } else {
        setNotifications([]);
        setUnseenCount(0);
      }
    } catch (err) {
      console.error("Error fetching notifications:", err);
      setNotifications([]);
      setUnseenCount(0);
    } finally {
      setLoading(false);
    }
  };

  // Mark all as seen
  const markAsSeen = async () => {
    try {
      await fetch(`${base_url}/notifications/mark-seen?email=${userEmail}`, {
        method: 'PUT'
      });
      setUnseenCount(0);
    } catch (err) {
      console.error("Error marking notifications as seen:", err);
    }
  };

  useEffect(() => {
       fetchNotifications();
  if (open) {
    markAsSeen().then(() => {
      fetchNotifications();
    });
  }
}, [open, range,location.pathname]);


  return (
    <>
      <Tooltip title="Notifications">
        <IconButton color="inherit" onClick={() => setOpen(true)}>
          <Badge badgeContent={notifications.filter(n => !n.seen).length} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>
      </Tooltip>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Notifications</DialogTitle>
        <DialogContent dividers>
          <Box alignItems={"center"} gap={1} display="flex" justifyContent="end" mb={2}>
            <Typography variant="h6" color="primary ">
              Filter by date:
            </Typography>
            <Select
              size="small"
              value={range}
              onChange={(e) => setRange(e.target.value)}
            >
              <MenuItem value="today">Today</MenuItem>
              <MenuItem value="week">This Week</MenuItem>
              <MenuItem value="month">This Month</MenuItem>
            </Select>
          </Box>

          {loading ? (
            <Box display="flex" justifyContent="center" mt={4}>
              <CircularProgress />
            </Box>
          ) : notifications.length === 0 ? (
            <Typography variant="body2" color="textSecondary" align="center">
              No notifications found.
            </Typography>
          ) : (
            <List>
              {notifications.map((notif, index) => (
                <ListItem key={index} divider alignItems="flex-start" sx={{ backgroundColor: !notif.seen ? '#f9f9f9' : 'inherit' }}>
                  <ListItemText
                    primary={
                      <Typography variant="subtitle1" fontWeight={notif.seen ? 'normal' : 'bold'}>
                        {notif.message} - <span style={{ color: '#1976d2' }}>{notif.ticketId}</span>
                      </Typography>
                    }
                    secondary={
                      <>
                       
                        <Typography variant="body2">
                          <strong>Issue:</strong> {notif.description || 'N/A'}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Priority:</strong> {notif.priority} | <strong>Assigned By:</strong> {notif.createdByName}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          {new Date(notif.createdAt).toLocaleString()}
                        </Typography>
                      </>
                    }
                  />
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default NotificationDialog;
